import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommandService, Reloadable } from '../../services/command/command.service';
import { CommandTemplate } from '../../entities/commandTemplate/commandTemplate';
import { ReactiveContainer } from '../../containers/reactive-container';
import { JobDetail } from '../../entities/jobDetail/jobDetail';
import * as fromGraphQl from '../job-admin/graphql';

@Component({
  selector: 'app-job-detail',
  templateUrl: './job-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobDetailComponent implements OnInit, Reloadable {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly commandService = inject(CommandService);

  /** Bindet sich selbst als Reloadable an die Trigger-Tabelle — siehe Global Constraints. */
  readonly self: Reloadable = this;

  private group = '';
  private name = '';

  private readonly container = new ReactiveContainer<fromGraphQl.JobDetailResponse>(
    fromGraphQl.JOB_DETAIL_QUERY,
    { pollInterval: 15000, stopPollingOnSuccess: false, useGlobalLoading: false }
  );

  readonly loading = this.container.loading;
  readonly error = this.container.error;

  readonly job = computed(() => {
    const data = this.container.data();
    return data?.getJobDetail ? new JobDetail(data.getJobDetail) : null;
  });

  readonly notFound = computed(
    () => !this.loading() && !this.error() && this.container.data() !== null && this.job() === null
  );

  ngOnInit(): void {
    this.group = this.route.snapshot.params['group'];
    this.name = this.route.snapshot.params['name'];
    this.container.execute({ group: this.group, name: this.name });
  }

  reload(): void {
    this.container.refetch({ group: this.group, name: this.name });
  }

  onCommand(command: CommandTemplate): void {
    const job = this.job();
    if (job) {
      this.commandService.execute(job, command, this);
    }
  }

  backToList(): void {
    this.router.navigate(['settings/job-admin']);
  }
}
